import React from "react";
import styled from "styled-components";

const ContentHeaderStyle = styled.div`
    gap: 40px;
    height: 60px;
    display: grid;
    padding: 0 40px;
    align-items: center;
    justify-content: space-between;
    grid-template-columns: minmax(150px, 1fr) auto;
    background-color: ${props => props.theme.greyLightest};
    border-bottom: 1px solid ${props => props.theme.greyLight};
`;

const TitleStyle = styled.div`
    font-size: 22px;
    white-space: nowrap;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${props => props.theme.black};
    overflow: hidden;
    text-overflow: ellipsis;
`;

const ControlStyle = styled.div`
    display: flex;
`;

export const ContentHeader = ({ title, children }) =>
    <ContentHeaderStyle>
        <TitleStyle>
            {title}
        </TitleStyle>
        <ControlStyle>
            {children}
        </ControlStyle>
    </ContentHeaderStyle>;